import { customerRequestQuestionsWireSchema, staffRequestQuestionsSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createCustomerRequestQuestionsApi(options) {
    const send = createMemoryTransport(options);
    const requestPath = (requestId) => `/customer/concierge-requests/${encodeURIComponent(requestId)}`;
    return {
        get: (requestId, callOptions) => send({
            method: "GET",
            path: requestPath(requestId),
            schema: customerRequestQuestionsWireSchema,
            signal: callOptions?.signal,
        }),
        answer: (requestId, questionId, input, commandOptions) => send({
            method: "POST",
            path: `${requestPath(requestId)}/questions/${encodeURIComponent(questionId)}/answer`,
            body: input,
            schema: customerRequestQuestionsWireSchema,
            idempotencyKey: commandOptions?.idempotencyKey,
            signal: commandOptions?.signal,
        }),
    };
}
export function createStaffRequestQuestionsApi(options) {
    const send = createMemoryTransport(options);
    return {
        list: (requestId, callOptions) => send({
            method: "GET",
            path: `/staff/concierge-requests/${encodeURIComponent(requestId)}/questions`,
            schema: staffRequestQuestionsSchema,
            signal: callOptions?.signal,
        }),
    };
}
